import Vue from 'vue';
import moment from 'moment';
import { getMonthPickerDate, getYesterdayPickerDate, getWeekPickerDate } from '@/components/pages/bonus/helpers/index';
export default Vue.extend({
    name: 'BonusConvertAhead',
    props: {
        filters: {
            type: Object,
            required: true
        },
        assetList: {
            type: Array,
            required: true
        }
    },
    data: () => ({
        isDatepickerOpen: false,
        tempDate: []
    }),
    computed: {
        computedDateView() {
            if (this.tempDate.length === 0)
                return this.$t('bonusesPage.tables.choose');
            if (this.tempDate.length === 1) {
                const yesterdayDate = getYesterdayPickerDate();
                if (this.tempDate[0] === yesterdayDate[0])
                    return this.$t('bonusesPage.tables.forYesterday');
                return moment(this.tempDate[0]).format('DD.MM.YYYY');
            }
            const weekDate = getWeekPickerDate();
            if (this.tempDate[0] === weekDate[0] && this.tempDate[1] === weekDate[1])
                return this.$t('bonusesPage.tables.forWeek');
            const monthDate = getMonthPickerDate();
            if (this.tempDate[0] === monthDate[0] && this.tempDate[1] === monthDate[1])
                return this.$t('bonusesPage.tables.forMonth');
            return `${moment(this.tempDate[0]).format('DD.MM.YYYY')} - ${moment(this.tempDate[1]).format('DD.MM.YYYY')}`;
        },
        selectedAsset() {
            const foundAsset = this.assets.find((item) => item.mark === this.filters.asset);
            if (foundAsset)
                return foundAsset.value;
            return '';
        },
        assets() {
            const assetMenuList = this.assetList.map((asset, i) => ({
                key: '' + (i + 1),
                value: asset,
                mark: asset
            }));
            return [{
                    key: '0',
                    value: 'Все',
                    mark: ''
                }].concat(assetMenuList);
        },
        isFiltersEmpty() {
            const filters = this.filters;
            return filters.dateTo === null && filters.dateFrom === null && filters.asset.length === 0;
        }
    },
    methods: {
        formatWeekday(date) {
            const weekday = moment(date).locale(this.$i18n.locale).format('dd');
            return weekday.charAt(0).toUpperCase() + weekday.slice(1);
        },
        updateTempDate(newDates) {
            if (newDates.length > 1 && newDates[0] === newDates[1]) {
                this.tempDate = [];
                return;
            }
            if (newDates.length > 1 && moment(newDates[1]).isBefore(newDates[0])) {
                this.tempDate = [newDates[1], newDates[0]];
                return;
            }
            this.tempDate = newDates;
        },
        updateSelectedAsset(newAsset) {
            if (this.filters.asset !== newAsset.mark) {
                this.$emit('onAssetChange', newAsset.mark);
            }
        },
        setYesterdayDate() {
            this.tempDate = getYesterdayPickerDate();
            this.isDatepickerOpen = false;
        },
        setWeekDate() {
            this.tempDate = getWeekPickerDate();
            this.isDatepickerOpen = false;
        },
        setMonthDate() {
            this.tempDate = getMonthPickerDate();
            this.isDatepickerOpen = false;
        }
    },
    watch: {
        isDatepickerOpen(v) {
            if (!v) {
                if (this.tempDate.length === 0) {
                    if (this.filters.dateFrom === null && this.filters.dateTo === null)
                        return;
                    this.$emit('onDateChange', {
                        dateTo: null,
                        dateFrom: null
                    });
                }
                if (this.tempDate.length === 1) {
                    const date = this.tempDate[0];
                    this.$emit('onDateChange', {
                        dateTo: date,
                        dateFrom: date
                    });
                }
                if (this.tempDate.length === 2) {
                    this.$emit('onDateChange', {
                        dateTo: this.tempDate[1],
                        dateFrom: this.tempDate[0]
                    });
                }
            }
        },
        filters: {
            handler(newFilters) {
                if (newFilters.dateTo === null && newFilters.dateFrom === null) {
                    this.tempDate = [];
                    return;
                }
                if (newFilters.dateTo === newFilters.dateFrom) {
                    this.tempDate = [newFilters.dateFrom];
                    return;
                }
                this.tempDate = [newFilters.dateFrom, newFilters.dateTo];
            },
            deep: true
        }
    }
});
